import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'rp-records-create-flow-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './create-flow-footer.component.html',
  styleUrls: ['./create-flow-footer.component.scss'],
})
export class CreateFlowFooterComponent {}
